import {
  GET_DOCUMENTS,
  SET_DOCUMENTS,
  GET_DOCUMENTS_ERROR,
  RESET_DOCUMENTS
} from './types'

const initialState = {
  documents: [],
  documentsNext: null,
  isLoadingDocuments: false
}

const documentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCUMENTS:
      return {
        ...state,
        isLoadingDocuments: true
      }
    case SET_DOCUMENTS:
      return {
        ...state,
        documents: action.payload.documents,
        documentsNext: action.payload.documentsNext,
        isLoadingDocuments: false
      }
    case GET_DOCUMENTS_ERROR:
      return {
        ...state,
        isLoadingDocuments: false
      }
    case RESET_DOCUMENTS:
      return {
        ...state,
        documents: [],
        isLoadingDocuments: false
      }
    default:
      return state
  }
}

export default documentsReducer
